import { useId } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "./Button";

/** Why the button is held — read out with it, and shown on hover. */
export const NO_STAND_REASON = "Unterlagen entstehen aus einem gespeicherten Stand — es gibt noch keinen.";

/**
 * „Unterlagen (PDF)" — the way from the board and from the calculation to
 * the printed documents of the Vorgang's latest Stand (design 2026-10-12 §3).
 *
 * A shared block because the two screens may not import each other (R-W1),
 * and one place for the wording and the rule: **held without a Stand**
 * (`aria-disabled`, reason in the name's description) — the documents are
 * made from a stored Stand and from nothing else.
 */
export function DocumentsButton({ caseId, versionNo }: { caseId: string; versionNo: number }) {
  const navigate = useNavigate();
  const reasonId = useId();
  const held = versionNo === 0;
  return (
    <>
      <Button
        variant="secondary"
        aria-disabled={held || undefined}
        aria-describedby={held ? reasonId : undefined}
        title={held ? NO_STAND_REASON : `Schema, Planungszeichnung und Stückliste von Stand ${versionNo}`}
        onClick={() => navigate(`/vorgang/${caseId}/unterlagen`)}
      >
        Unterlagen (PDF)
      </Button>
      {held ? (
        <span id={reasonId} className="visually-hidden">
          {NO_STAND_REASON}
        </span>
      ) : null}
    </>
  );
}
